import React from 'react';
import {
  Box, Typography, useTheme,
} from '@mui/material';

interface WalletSmallCardProps {
  smallCardId: string;
  smallCardTitle: string;
  smallCardContent: string;
  SmallCardIcon?: React.ComponentType;
  smallCardSubtitle?: string | null;
  optionalStyles?: React.CSSProperties;
}

export function WalletSmallInfoCard({
  smallCardId,
  smallCardTitle,
  smallCardContent,
  smallCardSubtitle,
  SmallCardIcon,
  optionalStyles = {},
}: WalletSmallCardProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        padding: `${theme.spacing(1.875)} ${theme.spacing(2.5)}`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0',
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${theme.palette.grey[200]}`,
        [theme.breakpoints.down('sm')]: { padding: `${theme.spacing(1.875)} ${theme.spacing(1)}` },
        ...optionalStyles,
      }}
    >
      <Box
        id='small-card-component-title-icon-box'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          alignSelf: 'stretch',
          mb: theme.spacing(1.875),
        }}
      >
        <Typography
          id='small-card-component-title'
          variant='h6'
          sx={{
            lineHeight: theme.spacing(2.5),
          }}
        >
          {smallCardTitle}
        </Typography>
        {SmallCardIcon && (
          <Box
            id='small-card-component-icon-box'
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: theme.palette.brand.primary,
              '& svg': {
                width: theme.spacing(2.5),
                height: theme.spacing(2.5),
              },
            }}
          >
            <SmallCardIcon/>
          </Box>
        )}
      </Box>
      <Typography
        data-testid={`${smallCardId}-content`}
        variant='h11'
        sx={{
          lineHeight: theme.spacing(3),
          mb: theme.spacing(0.625),
        }}
      >
        {smallCardContent}
      </Typography>
      {smallCardSubtitle && (
        <Typography
          data-testid={`${smallCardId}-subtitle`}
          variant='h13'
          sx={{
            lineHeight: theme.spacing(2),
          }}
        >
          {smallCardSubtitle}
        </Typography>
      )}
    </Box>
  );
}
